'use client';

import React from 'react';

import client from '@/clients/customer/api-client';

import { AppleIcon, Facebook, Google } from '@/components/ui/Icons';

async function getLoginUrl(provider: string) {
  const res = await client.get(`/login/${provider}`);
  return res.data;
}

interface Props {
  social_login: {
    is_active: string;
    facebook: string;
    google: string;
    apple: string;
  };
}

export default function SocialLogins({ social_login }: Props) {
  const handleSocialLogin = async (provider: string) => {
    const { login_url } = await getLoginUrl(provider);
    window.location.href = login_url;
  };
  return (
    <div className="mb-7 flex items-center justify-center space-x-4 2xl:mb-[40px]">
      {social_login?.facebook === 'yes' && (
        <button
          onClick={() => handleSocialLogin('facebook')}
          className="flex items-center rounded-[30px] border-[1.5px] border-neutral-100 px-[25px] py-[12px]"
        >
          <span className="me-[10px] hidden text-base text-paragraph sm:block">
            Facebook
          </span>
          <Facebook className="text-neutral-400" />
        </button>
      )}

      {social_login?.google === 'yes' && (
        <button
          onClick={() => handleSocialLogin('google')}
          className="flex items-center rounded-[30px] border-[1.5px] border-neutral-100 px-[25px] py-[12px]"
        >
          <span className="me-[10px] hidden text-base text-paragraph sm:block">
            Google
          </span>
          <Google />
        </button>
      )}

      {social_login?.apple === 'yes' && (
        <button
          onClick={() => handleSocialLogin('apple')}
          className="flex items-center rounded-[30px] border-[1.5px] border-neutral-100 px-5 py-2.5 sm:px-[25px] sm:py-3"
        >
          <span className="me-[5px] hidden text-base text-paragraph sm:block">
            Apple
          </span>
          <AppleIcon className="text-neutral-400" width={24} />
        </button>
      )}
    </div>
  );
}
